var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"fux-popup"},[_c('div',{attrs:{"id":"pop-wrapper"}},[_c('div',{staticClass:"pop-header",class:_vm.stClass},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"pop-content bg-gray"},[_vm._t("content")],2),_c('div',{staticClass:"pop-footer"},[_vm._t("footer")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }